// ** React Imports
import { NavLink } from "react-router-dom";

// ** Third Party Components
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

// ** Reactstrap Imports
import { Badge } from "reactstrap";
import { updateTab } from "../../../../../Pages/Reports/ReportActions";
import {
  RESET_VIDEO_PAGE,
  updateCampaignState,
  updatePublishedPageState,
  updateVideoPageState,
  updateParams as updateVideosParam
} from "../../../../../Pages/Video/VideoActions";
import {  updateParams as updateProductParams, updateProductPageState } from "../../../../../Pages/Product/productActions";
import { updateInfluencerPageState } from "../../../../../Pages/Influencer/influencer_actions";
import Cookies from "js-cookie";
import { clearSelectedVideos, updateWidgetState } from "../../../../../Pages/Widget/WidgetAction";


const VerticalNavMenuLink = ({ item, activeItem }) => {
  // ** Conditional Link Tag, if item has newTab or externalLink props use <a> tag else use NavLink
  const LinkTag = item.externalLink ? "a" : NavLink;
  const unreadMessageCounts = useSelector((state) => state.unreadMessageCounts);
  const totalMessageCount = Object.values(unreadMessageCounts).reduce(
    (sum, count) => sum + count,
    0
  );
  // ** Hooks
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <li
      className={classnames({
        "nav-item": !item.children,
        disabled: item.disabled,
        active: item.navLink === activeItem,
      })}
    >
      <LinkTag
        className="d-flex align-items-center"
        target={item.newTab ? "_blank" : undefined}
        /*eslint-disable */
        {...(item.externalLink === true
          ? {
              href: item.navLink || "/",
            }
          : {
              to: item.navLink || "/",
              className: ({ isActive }) => {
                if (isActive && !item.disabled) {
                  return "d-flex align-items-center active";
                }
              },
            })}
        onClick={(e) => {
          if (
            item.navLink.length === 0 ||
            item.navLink === "#" ||
            item.disabled === true
          ) {
            e.preventDefault();
          }
          if (item.title == "Reports") {
            dispatch(updateTab("All Reports", true));
          }
          if (item.title == "Products") {
            dispatch(
              updateProductPageState({
                isCategoryPage: true,
              })
            );
            dispatch(
              updateVideosParam({
                isFlaggedTab: false,
              })
            );
          }
          if (item.title == "Videos") {
            dispatch(
              updateVideoPageState({
                isCategoryPage: true,
              })
            );
            dispatch(updateCampaignState({
              breadcrumbs: [],
              showCampaignHeader: false
            }));
            //if Product isFavoriteTab is visited
            dispatch(
              updateProductParams({
                isFavoriteTab: false,
                isTrashTab: false,
              })
            );
            Cookies.remove("activeTab")
          }
          
          if (item.title == 'Widget') {
            dispatch(
              updatePublishedPageState({
                isCategoryPage: true,
              })
            );
            dispatch(updateWidgetState({ activeStep: 1}));
            dispatch(clearSelectedVideos());
          }
          
          if (item.title == 'Creators') {
            dispatch(
              updateInfluencerPageState({
                isCategoryPage: true,
              })
            );
          }
        }}
      >
        {item.icon}
        <span className="menu-item text-truncate">{t(item.title)}</span>

        {item.badge && item.badgeText && totalMessageCount ? (
          <Badge className="ms-1" color={item.badge} pill>
            {/* {item.badgeText} */}
            {totalMessageCount}
          </Badge>
        ) : null}
      </LinkTag>
    </li>
  );
};

export default VerticalNavMenuLink;